import { useState } from "react";

const KEY = "sleep-site-consent";

const read = () => {
  try { return localStorage.getItem(KEY); } catch { return "unknown"; }
};

export const CookieNote = () => {
  const [choice, setChoice] = useState(read);
  if (choice) return null;
  const decide = (value) => {
    try { localStorage.setItem(KEY, value); } catch { /* private mode */ }
    window.gtag?.("consent", "update", { analytics_storage: value });
    setChoice(value);
  };
  return (
    <div className="cookie-note" role="region" aria-label="Cookie choice" data-testid="cookie-note">
      <span>cookies for anonymous stats?</span>
      <button onClick={() => decide("granted")} data-testid="cookie-accept">accept</button>
      <button onClick={() => decide("denied")} data-testid="cookie-decline">decline</button>
    </div>
  );
};
